import { render, staticRenderFns } from "./TrackingData.vue?vue&type=template&id=638defc4&scoped=true&"
import script from "./TrackingData.vue?vue&type=script&lang=ts&"
export * from "./TrackingData.vue?vue&type=script&lang=ts&"
import style0 from "./TrackingData.vue?vue&type=style&index=0&id=638defc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638defc4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/llv-unitadmin/llv-unitadmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('638defc4')) {
      api.createRecord('638defc4', component.options)
    } else {
      api.reload('638defc4', component.options)
    }
    module.hot.accept("./TrackingData.vue?vue&type=template&id=638defc4&scoped=true&", function () {
      api.rerender('638defc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/partials/TrackingData.vue"
export default component.exports